import { selectAllowUpgrade, selectIntpWebsite, selectStpLimit } from '@va/aaas/shared/selectors';
import { PlanNames, TEST_IDS } from '@va/constants';
import { startUpgradeProcess } from '@va/dashboard/actions/app';
import { MaintenanceBanner } from '@va/dashboard/components';
import { useLocalizationContext } from '@va/localization';
import { PreHeaderBadge } from '@va/ui/design-system';
import { addNumberSeparator } from '@va/util/helpers';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const LayoutPreHeader = () => {
  return (
    <div className='flex flex-col pt-18px pl-18px pb-6px pr-6px gap-3 order-second empty:hidden'>
      <UpgradeBanner />
      <MaintenanceBanner render={(message) => <PreHeaderBadge message={message} />} />
    </div>
  );
};

const UpgradeBanner = () => {
  const dispatch = useDispatch();
  const { translate, locale } = useLocalizationContext();
  const allowUpgrade = useSelector(selectAllowUpgrade);
  const creditsLimit = useSelector(selectStpLimit);
  const intpWebsite = useSelector(selectIntpWebsite);
  const isFreePlan = intpWebsite.packageName === PlanNames.Free;
  const hasInfiniteCredits = useMemo(() => creditsLimit === -1, [creditsLimit]);

  if (hasInfiniteCredits || !isFreePlan) {
    return null;
  }

  return (
    <PreHeaderBadge
      message={translate('aaas.upgradeBanner.message', { credits: addNumberSeparator(creditsLimit, locale) })}
      actionText={allowUpgrade && translate('aaas.upgradeBanner.cta')}
      onActionClick={() => {
        dispatch(startUpgradeProcess());
      }}
      dataTestId={TEST_IDS.generic.banner.warning}
    />
  );
};
